/*
 * Copyright (c) 2018 Network International.
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { getCardIcon } from '../../card-icons/card-icons';
import styles from './styles.scss';

const CardLogo = ({ cardType }) => {
  const Icon = getCardIcon(cardType);
  if (!Icon) {
    return null;
  }

  return (
    <div className={styles.cardLogo}>
      <Icon data-testid={cardType} size={24} key={cardType} />
    </div>);
};

CardLogo.propTypes = {
  cardType: PropTypes.string.isRequired,
};

export default CardLogo;
